export default __webpack_public_path__ + "static/media/jove-logo-trans.e94e5e3b.svg";